/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";

export const RepeatIcon = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 4.6875L14.375 6.5625L12.5 8.4375"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 6.5625H5.625C4.79696 6.56497 4.00354 6.89501 3.41802 7.48052C2.83251 8.06604 2.50247 8.85946 2.5 9.6875V10.3125M7.5 15.3125L5.625 13.4375L7.5 11.5625"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 13.4375H14.375C15.203 13.435 15.9965 13.105 16.582 12.5195C17.1675 11.934 17.4975 11.1405 17.5 10.3125V9.6875"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
